<template>
<div class="chapter">
<div class="inner_page">
<h1>Acknowledgments</h1>
<p class="sectiontop">Some of the ideas included in the reading of the Tarot in this story were gleaned from <i>Tarot Made Easy</i>, Nancy Garen, A Fireside Book, Simon &amp; Schuster, 1989.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?67ebde49